import React from "react";
import { Text } from "@shopify/polaris";
import BannerCustom from "components/Banners/BannerCustom";
import AuthContainer from "../../AuthContainer";
import PageHelmet from "components/PageHelmet";
import useActivationPage from "../../shared/hooks/useActivationPage";

export default function ActivationPage() {
  const { t, activationError } = useActivationPage();

  return (
    <>
      <PageHelmet title="Activation" />
      <AuthContainer
        title={t("activation.userActivation")}
        content={
          !activationError ? (
            <Text>{t("activation.activationInProcess")}</Text>
          ) : (
            <BannerCustom
              status="critical"
              message={t("activation.linkInvalid")}
            />
          )
        }
      />
    </>
  );
}
